/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const CustomerCreatePage = lazyLoad(
  () => import('./index'),
  module => module.CustomerCreatePage
);
